import classNames from 'classnames';

type PropsCard = {
  title?: string;
  children?: JSX.Element | string;
  aspectRatio?: string;
  className?: string;
  classBody?: string;
  classHeader?: string;
  style?: object;
  onClick?: () => void;
}

export function Card(
  {
    title,
    children,
    aspectRatio,
    className,
    classBody,
    classHeader,
    style,
    onClick
  }: PropsCard
) {
  return (
    <div
      className={classNames(
        'card shadow overflow-visible rounded-3',
        className,
        { [`ratio ratio-${aspectRatio}`]: !!aspectRatio }
      )}
      tabIndex={-1}
      {...(onClick && {
        onClick,
        role: 'button',
        onKeyDown: onClick
      })}
      {...(style && { style })}
    >
      {title && (
        <div
          className={classNames(
            'card-header border-0 bg-white pb-1',
            classHeader
          )}
        >
          {title}
        </div>
      )}
      <div
        className={classNames(
          'card-body',
          classBody
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default Card;
